/* Vintage Cast Iron Radiators – gallery lightbox for article pages.
   Opens any .vcir-lightbox link inside a .vcir-gallery; arrows / swipe / Esc supported. */
(function () {
  'use strict';

  var ICON = {
    close: '<svg width="22" height="22" viewBox="0 0 22 22"><path d="M2 2l18 18M20 2L2 20" stroke="currentColor" stroke-width="1.6" fill="none"/></svg>',
    prev: '<svg width="26" height="44" viewBox="0 0 26 44"><path d="M24 2L4 22l20 20" stroke="currentColor" stroke-width="1.6" fill="none"/></svg>',
    next: '<svg width="26" height="44" viewBox="0 0 26 44"><path d="M2 2l20 20L2 42" stroke="currentColor" stroke-width="1.6" fill="none"/></svg>'
  };

  var overlay, imgEl, capEl, countEl, items = [], index = 0, lastFocus = null, touchX = null;

  function build() {
    overlay = document.createElement('div');
    overlay.className = 'vcir-lightbox-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Image viewer');
    overlay.innerHTML =
      '<span class="vcir-lb-count" aria-live="polite"></span>' +
      '<figure><img alt=""><figcaption></figcaption></figure>' +
      '<button type="button" class="vcir-lb-prev" aria-label="Previous image">' + ICON.prev + '</button>' +
      '<button type="button" class="vcir-lb-next" aria-label="Next image">' + ICON.next + '</button>' +
      '<button type="button" class="vcir-lb-close" aria-label="Close">' + ICON.close + '</button>';
    imgEl = overlay.querySelector('img');
    capEl = overlay.querySelector('figcaption');
    countEl = overlay.querySelector('.vcir-lb-count');

    overlay.querySelector('.vcir-lb-close').addEventListener('click', close);
    overlay.querySelector('.vcir-lb-prev').addEventListener('click', function (e) { e.stopPropagation(); step(-1); });
    overlay.querySelector('.vcir-lb-next').addEventListener('click', function (e) { e.stopPropagation(); step(1); });
    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
    overlay.addEventListener('touchstart', function (e) { touchX = e.changedTouches[0].clientX; }, { passive: true });
    overlay.addEventListener('touchend', function (e) {
      if (touchX === null) return;
      var dx = e.changedTouches[0].clientX - touchX;
      if (Math.abs(dx) > 40) step(dx < 0 ? 1 : -1);
      touchX = null;
    });
  }

  function show(i) {
    index = (i + items.length) % items.length;
    var a = items[index];
    var thumb = a.querySelector('img');
    imgEl.src = a.getAttribute('href');
    imgEl.alt = thumb ? thumb.alt : '';
    var caption = a.getAttribute('data-caption') || '';
    capEl.textContent = caption;
    capEl.hidden = !caption;
    countEl.textContent = items.length > 1 ? (index + 1) + ' / ' + items.length : '';
    var multi = items.length > 1;
    overlay.querySelector('.vcir-lb-prev').hidden = !multi;
    overlay.querySelector('.vcir-lb-next').hidden = !multi;
    // preload neighbours
    [index + 1, index - 1].forEach(function (n) {
      var nb = items[(n + items.length) % items.length];
      if (nb) { var im = new Image(); im.src = nb.getAttribute('href'); }
    });
  }

  function step(d) { show(index + d); }

  function onKey(e) {
    if (e.key === 'Escape') close();
    else if (e.key === 'ArrowRight') step(1);
    else if (e.key === 'ArrowLeft') step(-1);
    else if (e.key === 'Tab') {
      var btns = Array.prototype.filter.call(overlay.querySelectorAll('button'), function (b) { return !b.hidden; });
      var first = btns[0], last = btns[btns.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  }

  function open(gallery, start) {
    if (!overlay) build();
    items = Array.prototype.slice.call(gallery.querySelectorAll('a.vcir-lightbox'));
    lastFocus = document.activeElement;
    document.body.appendChild(overlay);
    show(start);
    document.documentElement.style.overflow = 'hidden';
    document.addEventListener('keydown', onKey);
    requestAnimationFrame(function () { overlay.classList.add('is-open'); });
    overlay.querySelector('.vcir-lb-close').focus();
  }

  function close() {
    overlay.classList.remove('is-open');
    document.removeEventListener('keydown', onKey);
    document.documentElement.style.overflow = '';
    setTimeout(function () { if (overlay.parentNode) overlay.parentNode.removeChild(overlay); }, 200);
    if (lastFocus) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.vcir-gallery a.vcir-lightbox');
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey) return;
    e.preventDefault();
    var gallery = a.closest('.vcir-gallery');
    var list = Array.prototype.slice.call(gallery.querySelectorAll('a.vcir-lightbox'));
    open(gallery, list.indexOf(a));
  });
})();
